<template>
  <div id="slide-entertainment" class="carousel slide" data-ride="carousel">
    <!-- Indicators -->
    <ul class="carousel-indicators">
      <li v-for="(item, i) in dataList" data-target="#slide-entertainment" :data-slide-to="i" :class="{active : i==0}"></li>
    </ul>

    <!-- The slideshow -->
    <div class="carousel-inner">
      <div class="carousel-item" v-for="(item, i) in dataList" :class="{active : i==0}">
        <a :href="checkLogin(loginRequest) == true ? prefixUrl + item.id + '/' + convertToAlias(item.title) : 'javascript:void(0)'"
           @click="redirectTo(checkLogin(loginRequest))" :title="item.title">
          <img :src="item.thumbnail" width="1100" height="500" :alt="item.title">
          <div class="carousel-caption">
            <h3>{{ subString(item.title, 80) }}</h3>
          </div>
        </a>
      </div>
    </div>

    <!-- Left and right controls -->
    <a class="carousel-control-prev" href="#slide-entertainment" data-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </a>
    <a class="carousel-control-next" href="#slide-entertainment" data-slide="next">
      <span class="carousel-control-next-icon"></span>
    </a>
  </div>
</template>

<script>
  export default {
    name: "SlideEntertainment",
    props:{
      loginRequest: String
    },
    data () {
      return {
        prefixUrl: this.settings.prefixNews,
        dataList: []
      }
    },
    methods: {
      getSlideNews(){
        axios.post(api.slieNews)
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("SlideNews-----");
            console.log(e);
          })
      }
    },
    watch: {
      "$route.path": {
        handler: "getSlideNews",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .carousel-inner img {
    width: 100%;
    height: 300px;
  }
  .carousel-caption h3{
    text-shadow: 1px 1px 1px #000;
    font-size: 20px;
  }
  .carousel-caption {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    padding-top: 10px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
  }
  .carousel-indicators{
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/entertainment/web/Slide.vue